<template>
  <div>
    <v-card>
      <aru-auto-form
        :key="editEvent.id ? editEvent.id : 'new-admin-calendar-event'"
        v-if="formConfig"
        v-model="formData"
        :form-configuration="formConfig"
        :dismiss-button="true"
        dismiss-text="Close"
        @submit="submit"
        @dismiss="$emit('closeDialog')"
      ></aru-auto-form>
    </v-card>
  </div>
</template>

<script>
import AruAutoForm from '@/components/commons/form/AruAutoForm';
export default {
  components: {
    AruAutoForm,
  },
  props: {
    formConfig: {
      type: Object,
    },
    editEvent: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formData: this.editEvent,
    };
  },
  mounted() {
    if (this.editEvent) {
      this.formData = this.editEvent;
    }
  },
  methods: {
    submit(data) {
      data.is_admin = true;

      this.$emit('submit', data);
    },
  },
  watch: {
    editEvent: {
      handler: function(val) {
        this.formData = this.editEvent;
      },
      deep: true,
    },
  },
};
</script>

<style></style>
